export const services = [
  "Acompanhamento de procedimento administrativos (Sindicância e IPM) e judiciais",
  "Ressarcimento de Preterição",
  "Conselho de Disciplina e Conselho de Justificação",
  "Remoção/Movimentação com ou sem ônus",
  "Reintegração/Reinclusão ao SAM, EB e FAB",
  "Impedimentos a Cursos de Formação de Cabo, Sargento e Oficiais",
  "Reforma de Militares na Esfera Administrativa/Judicial",
  "Descontos e/ou cobranças indevidas",
];
